export enum OrgAccountTypes {
  EMPTY = '',
  INDV = 'Individual',
  TRADITIONAL_IRA = 'Traditional IRA',
  ROTH_IRA = 'Roth IRA',
}

export enum OrgTriageAccountTypeNames {
  EMPTY = '',
  INDV = 'INDV',
  TRADITIONAL_IRA = 'TRADITIONAL_IRA',
  ROTH_IRA = 'ROTH_IRA',
}

export type OrgAccountTypeKey = keyof typeof OrgAccountTypes;

export function isOrgAccountTypeKey(value: unknown): value is OrgAccountTypeKey {
  return Object.keys(OrgAccountTypes).some((k) => k === value);
}
